import { connect } from 'react-redux';
import BudgetType2 from '../../../../views/Finance/Budgeting/Budget/BudgetType2.finance.view';


function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps, null)(BudgetType2);
